<div class="card-infi container">
  <div class="card-infi-header">
    <div class="row1">
      <img width="280" height="232" src="../../../../assets/resources/web/images/design/infi-gain-de-temps.png" alt="Partenariat in&fi">
      <img width="340" height="340" src="../../../../assets/resources/web/images/design/infi-logo.png" alt="Logo in&fi Crédits">
    </div>
    <div class="row2">
      <img width="238" height="156" src="../../../../assets/resources/web/images/design/infi-taux-negocies.jpg" alt="Partenariat in&fi">
      <img width="232" height="232" src="../../../../assets/resources/web/images/design/infi-conseillers-de-proximite.png" alt="Conseillers in&fi Crédits">
    </div>
  </div>
  <div class="card-infi-body">
    <h3 class="">Besoin d’aide pour <span class="text-infi"> <strong>financer votre projet</strong></span> immo ?</h3>
    <p class="bold-lg">Avec notre partenaire IN&FI Crédits, profitez des meilleurs taux du marché !</p>
    <p>Pour faciliter la concrétisation de vos projets de vie, nous avons le plaisir de collaborer avec IN&FI Crédits. Découvrez leurs services et estimez vos capacités d’emprunt.</p>
    <button (click)="onNavigateCapacite()" type="button" class="btn btn-success external-link-white">Calculer votre prêt immobilier</button>
  </div>
</div>
